module.exports = __webpack_public_path__ + "static/media/Major Project EXTC 2023-24.4104c2c2.pdf";